import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';

import { get as _get } from 'lodash';

import { neutrals1, blue } from '../../data/colors';
import DataContext from '../../data/data-context';

const useStyles = makeStyles(theme => ({
    footer: {
        width: '100%',
        position: 'fixed',
        textAlign: 'center',
        marginTop: '10px',
        background: theme.palette.nav.banner,
        zIndex: '2000',
        lineHeight: '30px',
        borderTop: '1px solid black',
        overflow: 'auto',
        bottom: 25,
        height: 31,
        color: theme.palette.common.white,
    },
    copyright: {
        width: '100%',
        position: 'fixed',
        textAlign: 'center',
        marginTop: '10px',
        background: theme.palette.nav.banner,
        zIndex: '2000',
        lineHeight: '30px',
        borderTop: '1px solid black',
        overflow: 'none',
        bottom: 0,
        fontSize: '12px',
        color: theme.palette.mode === 'light' ? neutrals1[100] : neutrals1[200],
        height: 25,
    },
    copyrightLink: {
        color: blue[500],
    },
}));

const FooterMessage = (props) => {
    const classes = useStyles();
    const { systemSettings } = useContext(DataContext);
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (systemSettings) {
            setMessage(_get(systemSettings, 'ui.messages.footer'));
        }
    }, [systemSettings]);

    return (
        <Box className={classes.footer}>{props.message || message || ''}</Box>
    );
};
FooterMessage.propTypes = {
    message: PropTypes.string,
};

const Copyright = () => {
    const classes = useStyles();
    const location = useLocation();

    return (
        <Box className={classes.copyright}>
            {location.pathname.includes('signin') && <span>
                © {new Date().getFullYear()} Open Text.
            </span>}
            {!location.pathname.includes('signin') && <span>
                © {new Date().getFullYear()} Open Text.
                One or more patents may cover this product(s).
                For more information, please visit &nbsp;
                <a
                    className={classes.copyrightLink}
                    target='_blank'
                    rel='noreferrer'
                    aria-label='patents'
                    href='https://www.opentext.com/patents'>
                        https://www.opentext.com/patents
                </a>.
            </span>}
        </Box>
    );
};

export {
    FooterMessage as default,
    Copyright
};
